import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import type { TableFilter } from '@pbt/pbt-ui-components'

import type { FilterOption } from '~/components/common/filters/BaseFilter'
import { KibSearchableSelect } from '~/components/common/filters/KibSearchableSelect'
import FeatureToggle from '~/constants/featureToggle'
import {
  getFeatureToggle,
  getInventorySubCategory,
} from '~/store/reducers/constants'

export interface SubcategoryFilterProps {
  onChange?: (selection: FilterOption) => void
  selectedCategoryFilter?: TableFilter
  selectedSubcategoryFilter?: TableFilter
}

const SubcategoryFilter = ({
  selectedCategoryFilter,
  selectedSubcategoryFilter,
  onChange,
}: SubcategoryFilterProps) => {
  const { t } = useTranslation('Common')
  const subcategoriesByCategoryId = useSelector(getInventorySubCategory)
  const isInventoryKibFiltersEnabled = useSelector(
    getFeatureToggle(FeatureToggle.INVENTORY_KIB_FILTERS),
  )

  const selectedCategoryIds = Array.isArray(selectedCategoryFilter?.value)
    ? selectedCategoryFilter.value.map(String)
    : []
  const selectedSubcategoryValues: string[] = Array.isArray(
    selectedSubcategoryFilter?.value,
  )
    ? selectedSubcategoryFilter.value.map(String)
    : []

  const noCategoriesSelected = selectedCategoryIds.length === 0

  const relevantSubcategories = Object.entries(
    subcategoriesByCategoryId || {},
  ).flatMap(([categoryId, subcategories]) => {
    if (noCategoriesSelected || selectedCategoryIds.includes(categoryId)) {
      return subcategories
    }

    return subcategories.filter((subcategory) =>
      selectedSubcategoryValues.includes(subcategory.id),
    )
  })

  if (!isInventoryKibFiltersEnabled) return null

  return (
    <KibSearchableSelect
      options={relevantSubcategories}
      placeholder={t('Common:SUB-CATEGORY')}
      selectedValues={selectedSubcategoryValues}
      onChange={onChange}
    />
  )
}

export default SubcategoryFilter
